// extracted by mini-css-extract-plugin
export default {"heading":"Title_heading__pwD10","small":"Title_small__BGdb9","medium":"Title_medium__DE1S-","large":"Title_large__rNMGB"};